import {
  concatStyleSets,
  FontWeights,
  IStyleFunctionOrObject,
  IToggleStyleProps,
  IToggleStyles,
  memoizeFunction,
} from '@fluentui/react';

const toggleInMenuStyles: Partial<IToggleStyles> = {
  root: {
    paddingTop: 5,
  },
  label: {
    order: 0,
    fontWeight: FontWeights.semibold,
    marginLeft: 10,
  },
  container: {
    order: 1,
    margin: `0 5px 0 10px`,
  },
  pill: {
    width: 40,
    height: 20,
  },
};

export const getToggleInMenuStyles = (): Partial<IToggleStyles> => {
  return toggleInMenuStyles;
};

export const getToggleInMenuStylesMerged = memoizeFunction(
  (
    customStyles: IStyleFunctionOrObject<IToggleStyleProps, IToggleStyles>
  ): IStyleFunctionOrObject<IToggleStyleProps, IToggleStyles> => {
    return (props: IToggleStyleProps) => {
      return concatStyleSets(
        toggleInMenuStyles,
        typeof customStyles === 'function' ? customStyles(props) : customStyles
      );
    };
  }
);
